import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProductCard6.vue?vue&type=template&id=4187a960"
import script from "./MoleculeEditionBillingAcademyProductCard6.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProductCard6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports